/* eslint-disable @typescript-eslint/no-require-imports */
import { createGlobalStyle } from 'styled-components'

export const GlobalStyle = createGlobalStyle`
    ${require('../../assets/style/base.css')}
`
/* eslint-enable @typescript-eslint/no-require-imports */
